module.exports = __webpack_public_path__ + "static/media/Donna_SIAA_Logo.b0ac0cb0.png";